import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {CategorySimpleSearchModel} from "../category-simple-search.model";
import {CategorySearchPageComponent} from "../category-search-page/category-search-page.component";
import {CategoryEditPageComponent} from "../category-edit-page/category-edit-page.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";

@Component({
    selector: "wbo-category-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(CategoryMultiSelectEditControlComponent),
        provideSearchModel(CategorySimpleSearchModel)
    ]
})
export class CategoryMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<CategorySimpleSearchModel> {
    constructor(model: CategorySimpleSearchModel, injector: Injector) {
        super(model, injector, "categoryId", "name");

        this.extendedSearchComponent = CategorySearchPageComponent;
        this.extendedEditComponent = CategoryEditPageComponent;
    }
}
